export class ListInventorySnapshotsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshots",
            "baseName": "snapshots",
            "type": "Array<Snapshot>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventorySnapshotsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
